import React from 'react';
import { Segment, Accordion, Header, Icon, Image } from 'semantic-ui-react';

class AboutPanel extends React.Component {

   // Initial State
  state = {
    currentUser : this.props.currentUser,
    channel: this.props.currentChannel, 
    privateChannel: this.props.isPrivateChannel,
    activeIndex: 0
  };

  // Method to set index
  setActiveIndex = (event, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;
    this.setState({ activeIndex: newIndex });
  };

  // Method to check if channel you are creating is valid
  notValidChannel = ({channel,currentUser}) => {

    if(channel && (channel.createdBy.id == currentUser.uid || (channel.users && (channel.users.indexOf(currentUser.uid) > -1)))){
      return false;
    }
    return true;

  }

  // Renders Semantic UI's Accordion Component in a Segment and accordion segments are decided by the above setActiveIndex method
  // Also reads in the state if it's a private channel or a public channel
  render() {
    const { activeIndex, privateChannel, channel , currentUser} = this.state;
    if (privateChannel) return null;

    if (this.notValidChannel(this.state)) return null;

    return (
      <Segment loading={!channel}>
        <Header as="h3" attached="top">
          About #{channel && channel.name}
        </Header>
        <Accordion styled attached="true">
          <Accordion.Title
            active={activeIndex === 0}
            index={0}
            onClick={this.setActiveIndex}
          >
            <Icon name="dropdown" />
            <Icon name="info" />
            Channel Info
          </Accordion.Title>
          <Accordion.Content active={activeIndex === 0}>
            {channel && channel.details}
          </Accordion.Content>

          <Accordion.Title
            active={activeIndex === 1}
            index={1}
            onClick={this.setActiveIndex}
          >
            <Icon name="dropdown" />
            <Icon name="user circle" />
            Admin
          </Accordion.Title>
          <Accordion.Content active={activeIndex === 1}>
            <Header as="h4">
              <Image circular src={channel && channel.createdBy.avatar} />
              {channel && channel.createdBy.name}
            </Header>
          </Accordion.Content>
        {
          currentUser.uid === (channel ? channel.createdBy.id : 0) && <>  <Accordion.Title
          active={activeIndex === 2}
          index={2}
          onClick={this.setActiveIndex}
        >
          <Icon name="dropdown" />
          <Icon name="sign-in" />
          Add Users
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 2} style={{"word-wrap": "break-word"}}>
        {channel && channel.joinUrl}
        <Icon name="copyToClipboard" onClick={() => {navigator.clipboard.writeText(channel.joinUrl)}}/>
        </Accordion.Content></>
        }
        </Accordion>
      </Segment>
    );
  }
}

export default AboutPanel;